import PropTypes from "prop-types";
import React from "react";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";

function Cost({ cost, currency, showYearly, className }) {
  const [integer = "0", decimal = "00"] = costToFrench(cost)
    ?.toString()
    ?.split(",") || ["-"];
  return (
    <div className={`cost__wrapper ${className}`}>
      <div className="cost__wrapper--main">
        <div className="cost__wrapper--main--integer">{integer}</div>
        <div>
          <div className="cost__wrapper--main--decimal">
            {`,${decimal} ${CURRENCY_SYMBOL[currency] || ""}`}
          </div>
          <div className="cost__wrapper--main--period">{"/mois"}</div>
        </div>
      </div>
      {showYearly && (
        <div className="cost__wrapper--secondary">
          {`par mois, soit ${(cost * 12)?.toFixed(2)}  par an`}
        </div>
      )}
    </div>
  );
}

Cost.propTypes = {
  cost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  currency: PropTypes.string.isRequired,
};

export default React.memo(Cost);
